/**
 * Next free SCN code (S7.1) — moved verbatim from `src/hooks/useProducts.ts`
 * into the pure lib so MSW handlers, the ScnLinkDrawer and the Spec Master
 * share ONE implementation (`useProducts` re-exports this).
 *
 * Auto-numbering follows the OEM/SCN board rule「系統自動產生：下一個可用流水號」
 * over the plain-serial `SCN-###` series. Semantic codes entered manually
 * (e.g. `UNIVERSAL-001` — permission-gated 自由編輯) never advance the serial:
 * they simply don't match the pattern. Pure, zero I/O — the caller supplies
 * the current groups.
 */

/** SCN plain-serial pattern — `SCN-` + digits (zero-padded to 3 on output). */
const SCN_SERIAL_PATTERN = /^SCN-(\d+)$/;

/** Next free SCN code (SCN-001 style) derived from the existing groups. */
export function nextScnCode(groups: ReadonlyArray<{ scn: string }>): string {
  let max = 0;
  for (const group of groups) {
    const match = SCN_SERIAL_PATTERN.exec(group.scn);
    if (match) max = Math.max(max, parseInt(match[1], 10));
  }
  return `SCN-${String(max + 1).padStart(3, '0')}`;
}
